import React from 'react';
import { Sparkles, Store, SquareStack, Calendar, Check } from 'lucide-react';
import { mockData } from '../data/mock';
import { Card, CardContent } from '../components/ui/card';

const iconMap = {
  Sparkles: Sparkles,
  Store: Store,
  SquareStack: SquareStack,
  Calendar: Calendar
};

const Services = () => {
  return (
    <section id="pakalpojumi" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-sky-100 text-sky-700 rounded-full text-sm font-medium mb-4">
            <Sparkles className="w-4 h-4" />
            <span>Mūsu pakalpojumi</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Ko mēs piedāvājam
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Pilns logu aprūpes pakalpojumu klāsts gan privātpersonām, gan uzņēmumiem
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {mockData.services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="border-2 border-gray-100 hover:border-sky-200 hover:shadow-lg transition-all duration-300 group"
              >
                <CardContent className="p-8">
                  <div className="flex items-start space-x-4">
                    <div className="w-14 h-14 bg-sky-100 group-hover:bg-sky-500 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors">
                      <Icon className="w-7 h-7 text-sky-600 group-hover:text-white transition-colors" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-gray-900 mb-3">
                        {service.title}
                      </h3>
                      <p className="text-gray-600 mb-6">
                        {service.description}
                      </p>
                      <ul className="grid grid-cols-2 gap-3">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="flex items-center space-x-2">
                            <div className="w-5 h-5 bg-sky-100 rounded-full flex items-center justify-center flex-shrink-0">
                              <Check className="w-3 h-3 text-sky-600" />
                            </div>
                            <span className="text-sm text-gray-700">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-8 md:mt-16 text-center pb-4 md:pb-0">
          <p className="text-gray-600 text-base md:text-lg px-4">
            Vai jums nepieciešams cits pakalpojums? Sazinies ar mums!
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
